import { Automation } from '@/types/automations.ts';
import { useContext } from 'react';
import { AutomationContext } from '@/context/AutomationContext/AutomationContext.tsx';

export function useAutomation(): Automation {
  const ctx = useContext(AutomationContext);
  if (!ctx) {
    throw new Error('useAutomation must be used within AutomationProvider');
  }
  return ctx;
}
